var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLogIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 4.66675V7.00008L8.16667 8.16675",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77917 6.41793C1.90989 5.13463 2.5085 3.94437 3.46077 3.07424C4.41304 2.20411 5.65233 1.71503 6.94219 1.70029C8.23204 1.68556 9.48218 2.14621 10.4541 2.99436C11.426 3.84251 12.0516 5.01879 12.2116 6.29877C12.3716 7.57875 12.0548 8.87283 11.3215 9.93412C10.5883 10.9954 9.49005 11.7496 8.23625 12.0528C6.98246 12.3561 5.66091 12.1871 4.52376 11.5781C3.3866 10.9692 2.51343 9.9629 2.07084 8.75126",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77917 11.6679V8.75122H4.69584",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogIcon);
export default __webpack_public_path__ + "static/media/menuLogIcon.60ecc5fb8861e2e5fbd844b7970401ad.svg";
export { ForwardRef as ReactComponent };